if (!customElements.get('announcement-bar-new')) {   
  class AnnouncementBarNew extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }
  
    connectedCallback() {
      this.initSlider();
    }
  
    initSlider(){
      if (!this.querySelector('[data-slider]')) return;
  
      this.options = {
        slidesPerView: 1,
        autoplay: {
          delay: 3000
        },
        loop: true
      }
  
      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options
      )
    }
  }
  
  customElements.define('announcement-bar-new', AnnouncementBarNew);
}
